import React from "react";
import { cn } from "@/lib/utils";

export type PillTone =
  | "neutral"
  | "brand"
  | "healthy"
  | "issue"
  | "critical"
  | "owned"
  | "influenced"
  | "earned"
  | "owner"
  | "billing"
  | "member"
  | "pending"
  | "active-plan";

type Props = {
  children: React.ReactNode;
  tone?: PillTone;
  /** Softer tinted-outline look for the status tones (healthy/issue/critical). */
  quiet?: boolean;
  /** Leading status dot in the current ink colour. */
  dot?: boolean;
  className?: string;
  title?: string;
};

/** One rectangular uppercase badge for the whole family — status (solid/quiet),
 *  orbit, role, brand/AI and neutral. Supersedes the scattered `.vb-tag`,
 *  `.vb-sev`, `.wb-sev`, `.vb-signal-pill`, `.src-pill-*` and shadcn badge. */
export function Pill({ children, tone = "neutral", quiet, dot, className, title }: Props) {
  return (
    <span
      title={title}
      className={cn("vb-pill", `vb-pill--${tone}`, quiet && "vb-pill--quiet", className)}
    >
      {dot && <span className="vb-pill__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}

export default Pill;
